// extracted by mini-css-extract-plugin
module.exports = {"toasts":"toasts_toasts__tvQM-","belowBanner":"toasts_belowBanner__TuIV2","toast":"toasts_toast__184YG","btn":"toasts_btn__10fe-"};